"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sqMeterToUnit = exports.areaToSqMeter = exports.convertArea = exports.unitStringForLengthUnit = exports.meterToUnit = exports.lengthToMeter = exports.convertLength = exports.LengthUnit = void 0;
var LengthUnit;
(function (LengthUnit) {
    LengthUnit[LengthUnit["meter"] = 0] = "meter";
    LengthUnit[LengthUnit["foot"] = 1] = "foot";
})(LengthUnit = exports.LengthUnit || (exports.LengthUnit = {}));
const FOOT_LENGTH = 0.3048;
const convertLength = (value, from, to) => {
    value = value === null ? NaN : value;
    if (!to && to !== 0) {
        return value;
    }
    return exports.meterToUnit(lengthToMeter(value, from), to);
};
exports.convertLength = convertLength;
function lengthToMeter(length, inUnit) {
    switch (inUnit) {
        case LengthUnit.foot:
            return length * FOOT_LENGTH;
        case LengthUnit.meter:
            return length;
    }
}
exports.lengthToMeter = lengthToMeter;
const meterToUnit = (meters, toUnit) => {
    switch (toUnit) {
        case LengthUnit.foot:
            return meters / FOOT_LENGTH;
        case LengthUnit.meter:
            return meters;
    }
};
exports.meterToUnit = meterToUnit;
function unitStringForLengthUnit(unit) {
    switch (unit) {
        case LengthUnit.meter:
            return 'm';
        case LengthUnit.foot:
            return 'ft';
    }
}
exports.unitStringForLengthUnit = unitStringForLengthUnit;
function convertArea(value, from, to) {
    value = value === null ? NaN : value;
    if (!to && to !== 0) {
        return value;
    }
    return sqMeterToUnit(areaToSqMeter(value, from), to);
}
exports.convertArea = convertArea;
function areaToSqMeter(length, inUnit) {
    switch (inUnit) {
        case LengthUnit.foot:
            return length * FOOT_LENGTH * FOOT_LENGTH;
        case LengthUnit.meter:
            return length;
    }
}
exports.areaToSqMeter = areaToSqMeter;
function sqMeterToUnit(squareMeters, toUnit) {
    switch (toUnit) {
        case LengthUnit.foot:
            return squareMeters / (FOOT_LENGTH * FOOT_LENGTH);
        case LengthUnit.meter:
            return squareMeters;
    }
}
exports.sqMeterToUnit = sqMeterToUnit;
//# sourceMappingURL=length.js.map